/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-Optimizer
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CashExposureType } from './CashExposureType';
import {
    CashExposureTypeFromJSON,
    CashExposureTypeFromJSONTyped,
    CashExposureTypeToJSON,
} from './CashExposureType';

/**
 * 
 * @export
 * @interface CashAllocationEnriched
 */
export interface CashAllocationEnriched {
    /**
     * 
     * @type {CashExposureType}
     * @memberof CashAllocationEnriched
     */
    exposureType: CashExposureType;
    /**
     * 
     * @type {number}
     * @memberof CashAllocationEnriched
     */
    currentExposure: number;
    /**
     * 
     * @type {number}
     * @memberof CashAllocationEnriched
     */
    targetExposure: number;
    /**
     * 
     * @type {number}
     * @memberof CashAllocationEnriched
     */
    activeExposure: number;
    /**
     * 
     * @type {string}
     * @memberof CashAllocationEnriched
     */
    tradeDate: string;
    /**
     * 
     * @type {string}
     * @memberof CashAllocationEnriched
     */
    pId: string;
    /**
     * 
     * @type {string}
     * @memberof CashAllocationEnriched
     */
    portfolioGuid?: string;
    /**
     * 
     * @type {string}
     * @memberof CashAllocationEnriched
     */
    portfolioName?: string;
    /**
     * 
     * @type {string}
     * @memberof CashAllocationEnriched
     */
    householdName?: string;
}



/**
 * Check if a given object implements the CashAllocationEnriched interface.
 */
export function instanceOfCashAllocationEnriched(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "exposureType" in value;
    isInstance = isInstance && "currentExposure" in value;
    isInstance = isInstance && "targetExposure" in value;
    isInstance = isInstance && "activeExposure" in value;
    isInstance = isInstance && "tradeDate" in value;
    isInstance = isInstance && "pId" in value;

    return isInstance;
}

export function CashAllocationEnrichedFromJSON(json: any): CashAllocationEnriched {
    return CashAllocationEnrichedFromJSONTyped(json, false);
}

export function CashAllocationEnrichedFromJSONTyped(json: any, ignoreDiscriminator: boolean): CashAllocationEnriched {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'exposureType': CashExposureTypeFromJSON(json['exposure_type']),
        'currentExposure': json['current_exposure'],
        'targetExposure': json['target_exposure'],
        'activeExposure': json['active_exposure'],
        'tradeDate': json['trade_date'],
        'pId': json['p_id'],
        'portfolioGuid': !exists(json, 'portfolio_guid') ? undefined : json['portfolio_guid'],
        'portfolioName': !exists(json, 'portfolio_name') ? undefined : json['portfolio_name'],
        'householdName': !exists(json, 'household_name') ? undefined : json['household_name'],
    };
}

export function CashAllocationEnrichedToJSON(value?: CashAllocationEnriched | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'exposure_type': CashExposureTypeToJSON(value.exposureType),
        'current_exposure': value.currentExposure,
        'target_exposure': value.targetExposure,
        'active_exposure': value.activeExposure,
        'trade_date': value.tradeDate,
        'p_id': value.pId,
        'portfolio_guid': value.portfolioGuid,
        'portfolio_name': value.portfolioName,
        'household_name': value.householdName,
    };
}

